import SuspenseWrapper from '~/components/misc/suspense-wrapper';
import { SidebarContent } from '~/components/sidebar';
import useWizard from '~/components/authentication/wizard/hooks/use-wizard';

const WizardSidebarContent = ({ children }) => {
	const { step } = useWizard();

	return (
		<SidebarContent className={step.className ?? ''}>
			<SuspenseWrapper withSuspense={step.withSuspense}>{children}</SuspenseWrapper>
		</SidebarContent>
	);
};

export default WizardSidebarContent;
